import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY } from "../constants";
export var pt = /*#__PURE__*/_defineProperty({}, CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY, {
  MODULE_HOME: 'Início',
  MODULE_RECOGNITION: 'Reconhecimento',
  MODULE_PERFORMANCE: 'Desempenho',
  MODULE_CLIMATE: 'Clima',
  MODULE_LEARNING: 'E-Learning',
  MODULE_COMPANY: 'Companhia',
  MODULE_ANALYTICS: 'Análise',
  MODULE_MY_RESULTS: 'Meus Resultados',
  TOOLTIP_CLIMATE_DESCRIPTION: 'Mede a cultura e satisfação da sua equipe.',
  TOOLTIP_PERFORMANCE_DESCRIPTION: 'Avalia o desempenho, através de objetivos e competências.',
  TOOLTIP_LEARNING_DESCRIPTION: 'Gerencia estratégias de aprendizado e potencializa as habilidades de suas equipes.',
  TOOLTIP_RECOGNITION_DESCRIPTION: 'Gerencia as medalhas concedidas pelos colaboradores.',
  TOOLTIP_COMPANY_DESCRIPTION: 'Monitora seus processos e gera relatórios.',
  TOOLTIP_ANALYTICS_DESCRIPTION: 'Consulta os resultados dos processos em que você participa.',
  TOOLTIP_MY_RESULTS_TITLE: 'Resultados',
  TOOLTIP_MY_RESULTS_DESCRIPTION: 'Analisa seus resultados e os da equipe que você lidera.',
  SUBMODULE_RESULTS_TITLE: 'Meus resultados',
  SUBMODULE_TOOLTIP_MY_RESULTS_DESCRIPTION: 'Consulta os resultados dos processos em que participa',
  SUBMODULE_LEADER_RESULTS_TITLE: 'Minha equipe',
  SUBMODULE_TOOLTIP_LEADER_RESULTS_DESCRIPTION: 'Monitora os resultados da sua equipe',
  SUBMODULE_DIRECTORY_TITLE: 'Diretório',
  SUBMODULE_TOOLTIP_DIRECTORY_DESCRIPTION: 'Informações dos membros da companhia',
  SUBMODULE_COMPANY_CHART_TITLE: 'Organograma',
  SUBMODULE_COMPANY_CHART_DESCRIPTION: 'Conheça a estrutura da companhia',
  SUBMODULE_RECOGNITION_TITLE: 'Medalhas',
  SUBMODULE_TOOLTIP_RECOGNITION_DESCRIPTION: 'Envie medalhas aos seus colegas e veja as que recebeu',
  SUBMODULE_RECOGNITION_REDEMPTION_TITLE: 'Recompensas',
  SUBMODULE_TOOLTIP_RECOGNITION_REDEMPTION_DESCRIPTION: 'Resgate os pontos que obteve por seus feitos',
  SUBMODULE_OKRS_PERFORMNACE_TITLE: 'OKRs',
  SUBMODULE_TOOLTIP_OKRS_PERFORMANCE_DESCRIPTION: 'Visualize o progresso da estratégia empresarial e reconheça o esforço para cumprir os objetivos',
  SUBMODULE_GOALS_TITLE: 'Metas',
  SUBMODULE_TOOLTIP_GOALS_DESCRIPTION: 'Planeje e estabeleça seus compromissos de trabalho',
  SUBMODULE_COMPETENCES_TITLE: 'Avaliações',
  SUBMODULE_TOOTLTIP_COMPETENCES_DESCRIPTION: 'Acesse os questionários dos processos atribuídos',
  SUBMODULE_FEEDBACK_TITLE: 'Feedback',
  SUBMODULE_TOOLTIP_FEEDBACK_DESCRIPTION: 'Avalie os processos de feedback da sua empresa.',
  SUBMODULE_PID_TITLE: 'Plano Individual de Desenvolvimento',
  SUBMODULE_TOOLTIP_PID_DESCRIPTION: 'Crie processos para fechar lacunas e promover o crescimento.',
  SUBMODULE_SUCESSION_PLAN_TITLE: 'Plano de Sucessão',
  SUBMODULE_TOOLTIP_SUCESSION_PLAN_DESCRIPTION: 'Crie planos de ação para futuras vagas.',
  SUBMODULE_CLIMATE_EVALUATION_TITLE: 'Avaliações de Clima',
  SUBMODULE_TOOLTIP_CLIMATE_EVALUATION_DESCRIPTION: 'Acesse o questionário para mediar o clima organizacional',
  SUBMODULE_SURVEY_TITLE: 'Pesquisas',
  SUBMODULE_TOOLTIP_SURVEY_DESCRIPTION: 'Ajude sua empresa a coletar informações de maneira rápida e fácil',
  // Learning links
  LEARNING_LINK_LEARND_AND_PROGRESS: 'APRENDIZAGEM E PROGRESSO',
  LEARNING_LINK_MORE_FOR_YOU: 'Mais Conteúdo',
  LEARNING_LINK_ENROLLED_COURSES: 'Cursos',
  LEARNING_LINK_TOOLTIP_MORE_FOR_YOU_DESCRIPTION: 'Descubra os novos conteúdos de aprendizado',
  LEARNING_LINK_PATHS: 'Trilhas de aprendizagem',
  LEARNING_LINK_LIVE_SESSIONS: 'Sessões ao vivo',
  LEARNING_LINK_NOTES: 'Anotações',
  LEARNING_LINK_STUDY_PLAN: 'Plano de Estudos',
  LEARNING_LINK_TOOLTIP_STUDY_PLAN: 'Planeje sua meta de aprendizado',
  LEARNING_LINK_MENTORSHIP: 'Mentorias',
  LEARNING_LINK_TOOLTIP_MENTORSHIP: 'Solicite orientação com especialistas',
  LEARNING_LINK_BLOG: 'Blog',
  LEARNING_LINK_LIVES: 'Lives',
  LEARNING_LINK_TOOLS: 'Ferramentas',
  LEARNING_LINK_EVALUATIONS_AND_GOALS: 'AVALIAÇÃO E CONQUISTAS',
  LEARNING_LINK_SKILL_XP: 'Skill XP',
  LEARNING_LINK_PROJECTS: 'Projetos',
  LEARNING_LINK_TOOLTIP_PROJECTS_DESCRIPTION: 'Realize os projetos dos seus cursos',
  LEARNING_LINK_DIPLOMA: 'Diplomas',
  LEARNING_LINK_TOOLTIP_DIPLOMA_DESCRIPTION: 'Consulte os diplomas obtidos pelo cumprimento do seu aprendizado',
  LEARNING_LINK_PENDING_TESTS: 'Testes Pendentes',
  LEARNING_LINK_DONE_TESTS: 'Testes Resolvidos',
  LEARNING_LINK_ACCHIEVEMENTS: 'Conquistas',
  LEARNING_LINK_REWARDS: 'Recompensas',
  LEARNING_LINK_SKILL_XP_EVOLUTION: 'Evolução de Skill XP',
  LEARNING_LINK_TOOLTIP_SKILL_XP_EVOLUTION_DESCRIPTION: 'Faça os testes e identifique o nível das suas habilidades',
  LEARNING_LINK_GAMIFICATION: 'Gamificação',
  LEARNING_LINK_TOOLTIP_GAMIFICATION_DESCRIPTION: 'Ganhe recompensas por suas conquistas de aprendizado',
  LEARNING_LINK_MY_COURSES: 'Meus Cursos',
  LEARNING_LINK_TOOLTIP_MY_COURSES_DESCRIPTION: 'Acesse cursos e caminhos em que está inscrito',
  LEARNING_LINK_RESOURCES: 'Recursos',
  LEARNING_LINK_TOOLTIP_RESOURCES_DESCRIPTION: 'Recursos de aprendizado',
  LEARNING_LINK_COURSES: 'Cursos',
  LEARNING_LINK_DISCOVER: 'Descubra',
  LEARNING_LINK_KNOWLEDGE_HUB: 'Catálogo',
  // Misc
  SIDEBAR_BACK: 'Voltar',
  SIDEBAR_BACK_TO_PRODUCTS: 'Voltar para meus produtos',
  SIDEBAR_EXPAND: 'Expandir menu',
  SIDEBAR_COLLAPSE: 'Recolher menu',
  SIDEBAR_HELP: 'Ajuda',
  SIDEBAR_HELP_DESCRIPTION: 'Acesse recursos e suporte de suporte.',
  MODULE_PRODUCTS_SUBTITLE: 'PRODUTOS',
  // Admin data
  MODULE_HANA: 'Hana AI',
  MODULE_ADMIN: 'Administração',
  MODULE_STATISTICS: 'Estatísticas',
  MODULE_REPORTS: 'Relatórios',
  MODULE_ANALYTICS_TOOLTIP_DESCRIPTION: 'Monitore seus processos e gere relatórios.',
  MODULE_HANA_TOOLTIP_DESCRIPTION: 'Analise os dados da sua empresa com Inteligência Artificial.',
  MODULE_RECOGNITION_TOOLTIP_DESCRIPTION: 'Gerencie as medalhas concedidas pelos colaboradores.',
  MODULE_PERFORMANCE_TOOLTIP_DESCRIPTION: 'Avalie o desempenho, através de objetivos e competências.',
  MODULE_CLIMATE_TOOLTIP_DESCRIPTION: 'Meça a cultura e satisfação da sua equipe.',
  MODULE_LEARNING_TOOLTIP_DESCRIPTION: 'Gerencie estratégias de aprendizado e potencialize as habilidades de suas equipes.',
  MODULE_ADMIN_TOOLTIP_DESCRIPTION: 'Gerencie seus usuários e as configurações da empresa.',
  MODULE_COMPANY_TOOLTIP_DESCRIPTION: 'Crie usuários e gerencie a estrutura organizacional.',
  MODULE_ACCOUNT: 'Conta',
  MODULE_ACCOUNT_TOOLTIP_DESCRIPTION: 'Gerencie os dados da conta e consulte o consumo de licenças.',
  MODULE_LOGS: 'Logs',
  MODULE_LOGS_TOOLTIP_DESCRIPTION: 'História das ações realizadas na conta.',
  MODULE_COMMUNICATION: 'Comunicação',
  MODULE_COMMUNICATION_TOOLTIP_DESCRIPTION: 'Personalize as notificações para seus usuários.',
  MODULE_COMPANY_USERS: 'Usuárias',
  MODULE_COMPANY_EXTRA_FIELDS: 'Atributos personalizados',
  MODULE_COMPANY_DEPARTMENTS: 'Departamentos',
  MODULE_COMPANY_JOBS: 'Empregos',
  MODULE_COMPANY_ORGCHART: 'Organização do organograma',
  // learning links
  LEARNING_LINK_CONTENT: 'Conteúdo',
  LEARNING_LINK_CONTENT_TOOLTIP_DESCRIPTION: 'Gerencie os cursos, trilhas de aprendizagem e outros recursos.',
  LEARNING_LINK_SKILL_XP_EVOLUTION_TOOLTIP_DESCRIPTION: 'Meça as habilidades de cada pessoa.',
  LEARNING_LINK_GAMIFICATION_TOOLTIP_DESCRIPTION: 'Crie, gerencie e premie conquistas de aprendizado.',
  LEARNING_LINK_PROGRESS: 'Progresso',
  LEARNING_LINK_ANALYTICS_TOOLTIP_DESCRIPTION: 'Monitore seus processos e gere relatórios.',
  LEARNING_LINK_SHOP: 'Loja',
  LEARNING_LINK_SHOP_TOOLTIP_DESCRIPTION: 'Personalize sua loja virtual de conteúdo.',
  LEARNING_LINK_INTEGRATIONS: 'Integrações',
  LEARNING_LINK_INTEGRATIONS_TOOLTIP_DESCRIPTION: 'Conecte a plataforma com outros sistemas.',
  // submodules
  SUBMODULE_RESULTS: 'Resultados',
  SUBMODULE_RESULTS_TOOLTIP_DESCRIPTION: 'Consulte os resultados dos processos em que participa.',
  SUBMODULE_MY_TEAM: 'Minha Equipe',
  SUBMODULE_MY_TEAM_TOOLTIP_DESCRIPTION: 'Monitore os resultados da sua equipe.',
  SUBMODULE_ADMIN_RESULTS: 'Resultados',
  SUBMODULE_ADMIN_RESULTS_TOOLTIP_DESCRIPTION: 'Monitore o ranking de medalhas obtidas pelos seus colaboradores.',
  SUBMODULE_REWARDS: 'Recompensas',
  SUBMODULE_REWARDS_TOOLTIP_DESCRIPTION: 'Gerencie e entregue as recompensas resgatadas.',
  SUBMODULE_CONFIGURATION: 'Configuração',
  SUBMODULE_CONFIGURATION_TOOLTIP_DESCRIPTION: 'Crie medalhas, defina regras e mensagens.',
  SUBMODULE_RESULTS_PERFORMANCE: 'Resultados',
  SUBMODULE_RESULTS_PERFORMANCE_TOOLTIP_DESCRIPTION: 'Meça o desempenho e o comprometimento das equipes.',
  SUBMODULE_COMPETENCES: 'Competências',
  SUBMODULE_COMPETENCES_TOOLTIP_DESCRIPTION: 'Crie e atribua avaliações de competências.',
  SUBMODULE_GOALS: 'Metas',
  SUBMODULE_GOALS_TOOLTIP_DESCRIPTION: 'Planeje e estabeleça seus compromissos de trabalho.',
  SUBMODULE_OKRS: 'OKRs',
  SUBMODULE_OKRS_TOOLTIP_DESCRIPTION: 'Visualize o progresso da estratégia empresarial e reconheça o esforço para cumprir os objetivos.',
  SUBMODULE_FEEDBACK: 'Feedback',
  SUBMODULE_FEEDBACK_TOOLTIP_DESCRIPTION: 'Meça os processos de feedback da sua companhia.',
  SUBMODULE_PID: 'Plano Individual de Desenvolvimento',
  SUBMODULE_PID_TOOLTIP_DESCRIPTION: 'Crie processos para fechar lacunas e promover o crescimento.',
  SUBMODULE_SUCCESSION_PLAN: 'Plano de Sucessão',
  SUBMODULE_SUCCESSION_PLAN_TOOLTIP_DESCRIPTION: 'Crie planos de ação para futuras vagas.',
  SUBMODULE_LINK_GOALS: 'Objetivos',
  SUBMODULE_LINK_ALIGNMENT: 'Alinhamento',
  SUBMODULE_LINK_CONFIGURATION: 'Configuração',
  SUBMODULE_CLIMATE_EVALUATION: 'Avaliações de Clima',
  SUBMODULE_CLIMATE_EVALUATION_TOOLTIP_DESCRIPTION: 'Acesse o questionário para mediar o clima organizacional.',
  SUBMODULE_SHORT_SURVEY: 'Pesquisas Curtas',
  SUBMODULE_SHORT_SURVEY_TOOLTIP_DESCRIPTION: 'Recolha informações de maneira rápida e fácil.',
  SUBMODULE_OTHER_EVALUATIONS: 'Outras Avaliações',
  SUBMODULE_OTHER_EVALUATIONS_TOOLTIP_DESCRIPTION: 'Avaliações adicionais, como riscos psicossociais.',
  SUBMODULE_CONFIGURATION_MEDALS: 'Medallas',
  SUBMODULE_CONFIGURATION_MESSAGES: 'Mensajes',
  SUBMODULE_CONFIGURATION_RULES_AND_PERMISSIONS: 'Regras e permissões',
  SUBMODULE_TALENT: 'Talent',
  SUBMODULE_LEARNING: 'E-Learning',
  SUBMODULE_NBOX: 'N-Box',
  SUBMODULE_NBOX_TOOLTIP_DESCRIPTION: 'Crie variáveis ​​de cruzamento de matrizes para visualizar dados.',
  MODULE_APPEREANCE: 'Aparência',
  MODULE_APPEREANCE_TOOLTIP_DESCRIPTION: 'Personalize o painel com a identidade organizacional',
  MODULE_AUTOMATIZATIONS: 'Automatizações',
  MODULE_AUTOMATIZATIONS_TOOLTIP_DESCRIPTION: 'Crie regras de automatização para agilizar tarefas',
  SUBMODULE_MEDALS_REQUETS: 'Solicitação de medalhas',
  SUBMODULE_MEDALS_REQUETS_TOOLTIP_DESCRIPTION: 'Aprove ou rejeite as medalhas enviadas pelos colaboradores.'
});